module.exports = __webpack_public_path__ + "usuario-01.28793e416aeea54434a37e2c82138a86.png";